import * as React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { validateUUID } from '@utils/helpers'
import { useContext } from 'react'
import { SubmissionContext } from '@app/context/SubmissionProvider'

const validationSchema = yup.object({
  submissionId: yup.string().test('is-uuid', 'Invalid Claim ID', validateUUID),
})

export const ClaimTrackerView: React.FC = () => {
  const intl = useIntl()
  let context = useContext(SubmissionContext)

  const formik = useFormik({
    initialValues: {
      submissionId: '',
    },
    validationSchema,
    onSubmit: context.getStatus,
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="form-field-text form-field-firstname field field--full">
        <div className="field__content">
          <label className="label">
            <FormattedMessage defaultMessage="Claim ID" /> *
          </label>
          <div className="field__wrapper field__wrapper--full">
            <div className="input-base">
              <input
                className="input"
                id="submissionId"
                name="submissionId"
                type="text"
                required={true}
                value={formik.values.submissionId}
                onChange={formik.handleChange}
                autoComplete="off"
                placeholder={intl.formatMessage({
                  defaultMessage: 'Enter your Claim Id, e.g. 1d1d1a1a-9c9c-2b2b-3c3c-1kd9837yfhdj',
                })}
              />
            </div>
          </div>
        </div>
        <span className={`field__msg ${formik.errors.submissionId ? 'field__msg--error field--state field__msg--active' : ''}`}>{formik.errors.submissionId}</span>
      </div>

      <footer className="step__footer">
        <button
          className={`btn btn--primary ${formik.isValid ? '' : 'btn--disables'}`}
          type="submit"
          disabled={!formik.isValid}
        >
          <FormattedMessage defaultMessage='Next'/>
        </button>
      </footer>
    </form>
  )
}
